import styled from 'styled-components'
import { media, colors, radiuses } from 'styles'

const { medium, large } = radiuses

const StyledUserPanel = styled.div`
  position: relative;
  border-radius: ${medium} ${medium} 0 0;
  color: ${colors.textMain};

  &:hover {
    box-shadow: 0 0 1rem ${colors.boxShadow};

    .toggle {
      background-color: ${colors.mainBackground};
    }

    .content {
      visibility: visible;
    }
  }

  .toggle {
    box-sizing: border-box;
    padding: 1rem;
    z-index: 5;
    position: relative;
    border-radius: ${medium} ${medium} 0 0;
    display: flex;

    .avatar {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      margin-right: 1rem;
    }

    .dropdown-icon {
      align-items: flex-start;
    }
  }
  .user-info {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    margin-right: 1rem;

    p {
      margin: 0;
    }

    .username {
      font-size: 1.2rem;
      font-weight: 700;
    }

    .membership {
      font-size: 1rem;
      color: ${colors.textSecondary};
      text-transform: uppercase;
    }
  }
  .content {
    visibility: hidden;
    position: absolute;
    right: 0;
    z-index: 4;
    display: flex;
    flex-wrap: wrap;
    width: 32rem;
    padding: 1rem;
    border-radius: ${large} 0 ${large} ${large};
    background-color: ${colors.mainBackground};
    box-shadow: 0 0 1rem ${colors.boxShadow};

    .avatar-link,
    .actions {
      flex: 1 0 10rem;
      box-sizing: border-box; // flex base >= 2rem and box-sizing needed so avatar and actions are same width
    }

    .actions {
      padding: 0 1rem;
      margin-left: 1rem;
    }

    .actions-link {
      display: flex;
      align-items: center;
      text-decoration: none;
      color: inherit;
      padding: 1rem 0;
      font-size: 1.4rem;
      cursor: pointer;
      text-transform: capitalize;
      i {
        margin-right: 1rem;
        font-size: 1.4rem;
        color: inherit;
      }

      ~ .actions-link {
        border-top: 1px solid ${colors.divider};
      }
    }

    .actions-link:hover {
      color: ${colors.highlight};
    }

    .TranslationSwitch {
      display: flex;
      flex-flow: row wrap;
      margin-top: 1rem;

      .translation {
        flex: 1 0 35%;
        margin-right: 3rem;
        margin-bottom: 0.5rem;
        padding: 0.6rem 0 0.6rem 0.5rem;
        box-sizing: border-box;
        font-size: 1.2rem;
        cursor: pointer;

        &:hover {
          background-color: ${colors.mainBackground};
        }
      }

      .translation--active {
        font-weight: 700;
      }
    }
  }

  @media (min-width: 1280px) {
    .chat-open & .user-info {
      display: none;
    }
  }
  ${media.tablet`
    .user-info { display: none; }
  `}
`

export default StyledUserPanel
